export function isWhite({red, green, blue}) {
  return red > 253 && green > 253 && blue > 253;
}

export function isBlack({red, green, blue}) {
  return red === 0 && green === 0 && blue === 0;
}

export function isNone({red, green, blue}) {
  return [red, green, blue].some(
    channel => typeof channel !== 'number' || isNaN(channel)
  );
}

export function isPureMagenta({red, green, blue}) {
  return red === 255 && green === 0 && blue === 255;
}

export function getColorName(color) {
  return color && color.name.replace(' ', '_').toLowerCase();
}
